const STATS = [
    { value: "55 %", label: "de frais économisés en moyenne par an" },
    { value: "3 semaines", label: "durée moyenne d'une mission" },
    { value: "70 %", label: "jusqu'à 70 % des frais économisés" },
];

const PRESS = [
    {
        href: "https://www.bfmtv.com/economie/professionnels/focus-entreprises/fod-le-pure-player-de-l-optimisation-des-frais-bancaires_AB-202501270025.html",
        label: "FOD vu sur BFM Business (nouvel onglet)",
        src: "/media/bfm-business-logo.svg",
        alt: "BFM Business",
        w: 64,
        h: 64,
    },
    {
        href: "https://www.parlonsfinance.fr/articles/optimiser-ses-frais-bancaires-le-gisement-de-tresorerie-oublie-des-pme-et-eti",
        label: "Article Parlons Finance (nouvel onglet)",
        src: "/media/parlons-finance-logo.png",
        alt: "Parlons Finance",
        w: 175,
        h: 56,
    },
];

export const StatsBand = () => (
    <section className="bg-cream border-b border-border-default" data-testid="home-stats">
        <div className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-6 md:py-9 grid grid-cols-1 sm:grid-cols-3 gap-0 sm:gap-7 divide-y divide-border-default sm:divide-y-0">
            {STATS.map((s) => (
                <div key={s.label} className="grid grid-cols-[150px_1fr] items-center gap-4 py-4 first:pt-0 last:pb-0 sm:py-0 sm:flex sm:flex-col sm:items-center sm:gap-1.5 text-left sm:text-center">
                    <span className="font-bold text-[26px] sm:text-[32px] md:text-[40px] whitespace-nowrap lg:text-[46px] leading-none tracking-[-0.02em] text-navy">
                        {s.value}
                    </span>
                    <span className="text-sm leading-snug text-grey-text-soft">{s.label}</span>
                </div>
            ))}
        </div>
    </section>
);

export const PressBand = () => (
    <section
        aria-label="Vu dans les médias"
        data-testid="home-press"
        className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-6 md:py-9 flex flex-wrap items-center justify-center gap-x-16 gap-y-4"
    >
        <span className="text-[13px] font-semibold uppercase tracking-[0.16em] text-grey-text-soft">Vu sur</span>
        <div className="flex flex-wrap items-center justify-center gap-x-16 gap-y-5">
            {PRESS.map((p) => (
                <a
                    key={p.alt}
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={p.label}
                    data-testid={`press-${p.alt.toLowerCase().replace(/\s+/g, "-")}`}
                    className="inline-flex rounded-md transition-[transform,opacity] opacity-90 hover:opacity-100 hover:-translate-y-0.5"
                >
                    <img src={p.src} alt={p.alt} width={p.w} height={p.h} className="h-11 md:h-14 w-auto object-contain" />
                </a>
            ))}
        </div>
    </section>
);
